import React from 'react';
import styles from './EventsSection.module.css';

const EventsSection = () => {
    return (
        <>
            {/* Desktop Events Section */}
            <section className={styles.eventsSectionDesktop}>
                <div className={styles.backgroundOverlay}>
                    <div className={styles.backgroundOrange}></div>
                    <div className={styles.backgroundContent}></div>
                </div>
                <div className={styles.eventsContent}>
                    <div className={styles.eventsInner}>
                        <div className={styles.eventsWrapper}>
                            <div className={styles.textContainer}>
                                <div className={styles.whiteBox}>
                                    <h2 className={styles.eventsTitle}>
                                        <span className={styles.eventsText}>
                                            No events at the moment
                                        </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Events Section */}
            <section className={styles.eventsSectionMobile}>
                <div className={styles.backgroundOverlay}>
                    <div className={styles.backgroundOrange}></div>
                    <div className={styles.backgroundContent}></div>
                </div>
                <div className={styles.eventsContent}>
                    <div className={styles.eventsInner}>
                        <div className={styles.eventsWrapper}>
                            <div className={styles.textContainer}>
                                <div className={styles.whiteBox}>
                                    <h2 className={styles.eventsTitle}>
                                        <span className={styles.eventsText}>
                                            No events at the moment
                                        </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EventsSection;